import { api } from "@libs/api/client";
import { ApiDynamicData } from "@libs/api/types";

export type getProductResponse = ApiDynamicData<'queries', 'get'>

export const getConsultationByid = async (id: string): Promise<getProductResponse> => {
  const { data } = await api.queries({ id }).get();
  return data;
}